import { createContext } from 'react';

const ScrollContext = createContext({
	scrollingElement: null,
});
export default ScrollContext;
